import { DatePipe } from "@angular/common";
import {
    Component,
    EventEmitter,
    Input,
    OnInit,
    Output,
    ViewChild
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import * as _ from "lodash";
import * as fromRootStore from "../../../reducers";
import { CommonService } from "../../../services/common.service";
import {
    Combo2Service,
    ExcelService,

    PurchaseReportService
} from "../../../services/index";
import { PurchaseOrderService } from "../../../services/purchaseorder.service";
declare var google;

@Component({
  selector: "purchaseOrder",
  host: { "(window:keydown)": "hotkeys($event)" },
  templateUrl: "./factoryStockreport.html",
})
export class factoryStockreport implements OnInit {
  @Input("tabTitle") title: string;
  @Input("tabID") tabID: string;
  @Input("params") params: any;
  @Input() active = false;
  @Input() dataContext;
  @Output() tabUpdateEvent = new EventEmitter();

  seasonList = [];
  styleList = [];
  gridOptions: any;
  dataList = [];
  qualityList: any;
  typeList: any;
  colorList: any;
  codeList: any;
  widthList: any[];
  brandList: any[];
  isLoadMask: Promise<any>;
  selectedDlrMapList: any[];
  loadingIndicator: boolean = true;
  reorderable: boolean = true;
  finyearList = [];
  exceldata: any;
  groupbyList = ["DESIGN NO", "WO NO"];
  filter = {
    groupby: "WO NO",
    shirtdno: "",
    from_date: "",
    to_date: "",
    party_code: "",
    wo_no: "",
    width: [],
    brand: [],
    style: [],
  };
  page = {
    limit: 25,
    count: 0,
    offset: 0,
    orderBy: "wo_no",
    orderDir: "asc",
  };
  printConfig: any = {
    title: "WorkOrder Report",
    columns: [],
    rows: [],
  };

  partyList = [];

  // @ViewChild('snoTemplate') snoTemplate: TemplateRef<any>;
  // @ViewChild('nameTemplate') nameTemplate: TemplateRef<any>;
  // @ViewChild('addrTemplate') addrTemplate: TemplateRef<any>;
  //   @ViewChild('editDeleteTemplate') editDeleteTemplate: TemplateRef<any>;
  @ViewChild("filterPanel") filterPanel;
  //   @ViewChild('partyDataTable') partyDataTable;

  finyearCtrl: FormControl = new FormControl();
  seasonCtrl: FormControl = new FormControl();
  agentCtrl: FormControl = new FormControl();
  partyCtrl: FormControl = new FormControl();
  parentCtrl: FormControl = new FormControl();
  columns = [];
  partycodeList = [];
  toggleCol = [];
  menu: any;
  reportTypeList = ["DESIGN NO", "PARTY", "PURCHASE"];
  reportName = "design_no";
  reportType = "Design";
  filterExpand = false;
  filterData: any;
  agentList$ = [];
  swatchList = ["YES", "NO"];
  sampList = ["YES", "NO"];
  user: any;
  agentVisible: boolean = false;
  companyInfo: any = [];
  orderList: any = [];
  constructor(
    public store: Store<fromRootStore.State>,
    private commonserv: CommonService,
    private poservice: PurchaseOrderService,
    private excelService: ExcelService,
    private purReport: PurchaseReportService,
    public datePipe: DatePipe,
    private combo2Service: Combo2Service,
    public toasterService: ToasterService
  ) {}

  ngOnInit(): void {
    this.getColumns();
    // this.finyearCombo();
    // this.widthlist();
    this.brandlist();
    this.toggleCol = Object.assign({}, this.columns);
  }

  hotkeys(event) {
    if (this.active) {
    }
  }

  getColumns() {
    this.columns = [
      {
        name: "SNo",
        prop: "sno",
        type: "sno",
        minWidth: 80,
        maxWidth: 80,
        width: 80,
        sortable: false,
        toggle: true,
        cellClass: "text-center",
        headerClass: "text-center",
      },
      {
        name: "WO.NO",
        prop: "wo_no",
        minWidth: 130,
        maxWidth: 130,
        width: 130,
        headerClass: "text-center",
      },
      {
        name: "Fabric Design",
        prop: "fab_design",
        minWidth: 130,
        maxWidth: 130,
        width: 130,
        headerClass: "text-center",
      },
      {
        name: "Shirt design",
        prop: "shirtdno",
        cellClass: "text-right",
        minWidth: 100,
        maxWidth: 100,
        width: 100,
        headerClass: "text-center",
      },
      {
        name: "Width",
        prop: "width",
        cellClass: "text-center",
        minWidth: 120,
        maxWidth: 120,
        width: 120,
        headerClass: "text-center",
      },
      {
        name: "Brand",
        prop: "brand",
        cellClass: "text-right",
        minWidth: 100,
        maxWidth: 100,
        width: 100,
        headerClass: "text-center",
      },
      {
        name: "F/S",
        prop: "ftot",
        cellClass: "text-right",
        minWidth: 100,
        maxWidth: 100,
        width: 100,
        headerClass: "text-center",
      },
      {
        name: "H/S",
        prop: "htot",
        cellClass: "text-right",
        minWidth: 100,
        maxWidth: 100,
        width: 100,
        headerClass: "text-center",
      },
      {
        name: "GR.Tot",
        prop: "gr_tot",
        cellClass: "text-right",
        minWidth: 100,
        maxWidth: 100,
        width: 100,
        headerClass: "text-center",
      },
    ];

    this.gridOptions = {
      columns: this.columns,
      loading: true,
      data: [],
    };
    this.toggleCol = Object.assign({}, this.columns);

    this.pageCallback({ offset: 0 });
  }

  onOpenedFilter(): void {
    setTimeout(function () {
      $("#party_code").focus();
    }, 100);
  }
  exportToExcel($event) {
    this.excelService.exportAsExcelFile(this.exceldata, this.title);
  }

  onChangePageSize(limit) {
    this.page.limit = 10000;
    //this.getSalesinvReport();
  }

  onColumnToggle(colToShow) {
    this.columns = colToShow;
  }

  onEnterKeyPressed(nextEl: string, ind, item) {
    if ($(".swal2-container").length > 0) {
      return false;
    } else {
      let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
      a.removeClass("mat-autocomplete-visible");
      $("#" + nextEl).focus();
    }
  }

  /**
   * Called whenever the user changes page
   */
  pageCallback(pageInfo: {
    count?: number;
    pageSize?: number;
    limit?: number;
    offset?: number;
  }) {
    this.page.offset = pageInfo.offset;
    this.getOrderList();
  }

  /**
   * Called whenever the user changes the sort order
   */
  sortCallback(sortInfo: {
    sorts: { dir: string; prop: string }[];
    column: {};
    prevValue: string;
    newValue: string;
  }) {
    // there will always be one "sort" object if "sortType" is set to "single"
    this.page.orderDir = sortInfo.sorts[0].dir;
    this.page.orderBy = sortInfo.sorts[0].prop;
    // this.getSalesinvReport();
  }

  widthlist() {
    this.poservice.widthlist({}).then((res: any) => {
      this.widthList = res.data;
    });
  }
  brandlist() {
    let data = this.commonserv.itemMaster();
    let brand = data.brand;
    this.brandList = brand;
    let style = data.style;
    this.styleList = style;
  }

  onClickwidth(selected, name, status) {
    if (status == true) {
      selected.push(name);
      this.filter.width = selected;
      //this.fil['brand'] = selected;
    }
    if (status == false) {
      var n = selected.indexOf(name);
      selected = selected.splice(n, 1);
    }
  }
  onClickbrand(selected, name, status) {
    if (status == true) {
      selected.push(name);
      this.filter.brand = selected;
      //this.fil['brand'] = selected;
    }
    if (status == false) {
      var n = selected.indexOf(name);
      selected = selected.splice(n, 1);
    }
  }
  onClickstyle(selected, name, status) {
    if (status == true) {
      selected.push(name);
      this.filter.style = selected;
      //this.fil['brand'] = selected;
    }
    if (status == false) {
      var n = selected.indexOf(name);
      selected = selected.splice(n, 1);
    }
  }

  applyFilter(): void {
    //this.filterExpand = false;
    if (this.filter.party_code == "") {
      this.filter["party_id"] = "";
    }
    this.filter.wo_no = "";
    //  this.filterPanel.close();
    this.getOrderList();
  }
  woFilter(wo_no) {
    this.filter.wo_no = wo_no;
    this.filter.groupby = "";
    this.filter.style = [];
    this.filter.from_date = "";
    this.filter.to_date = "";
    this.filter.party_code = "";
    this.getOrderList();
    this.filter.wo_no = "";
  }
  loadSeasonList() {
    let that = this;
    this.combo2Service.seasonCombo().then(function (res) {
      //  this.LoadAgentList();
      that.seasonList = res.data;
      that.seasonCtrl.setValue(res.data[0].season_id);
    });
  }

  finyearCombo() {
    let that = this;
    this.combo2Service.finyearCombo().then((res: any) => {
      that.finyearList = res.data;
      that.finyearCtrl.setValue(res.data[0].fin_id);
    });
  }

  displayFinyear(comboType: string, id: number) {
    let list: any = [];
    if (comboType == "Finyear") {
      list = this.finyearList;
    }

    if (id && list.length > 0) {
      let fitem = _.find(list, { fin_id: id });
      return fitem["finyear"];
    }
    return "";
  }

  getOrderList(): void {
    this.filter.from_date = this.datePipe.transform(
      this.filter.from_date,
      "yyyy-MM-dd"
    );
    this.filter.to_date = this.datePipe.transform(
      this.filter.to_date,
      "yyyy-MM-dd"
    );
    //this.filter.order_to_date = this.datePipe.transform(this.filter.order_to_date, 'yyyy-MM-dd');
    let params = {
      start: `${this.page.offset * (this.page.limit + 1)}`,
      limit: `${this.page.limit}`,
      page: "1",
      orderColumn: `${this.page.orderBy}`,
      orderDir: `${this.page.orderDir}`,
      filter: JSON.stringify(this.filter),
    };
    let that = this;
    that.gridOptions = {
      loading: true,
      columns: [],
    };
    //this.store.dispatch(new commonActions.LoadAllParty(params));
    this.isLoadMask = this.purReport
      .getFactoryStockreport(params)
      .then(function (res: any) {
        that.loadingIndicator = false;
        that.page.count = res.totCnt;
        that.orderList = res.data;

        that.gridOptions = {
          cols: res.cols,
          columns: res.columns,
          data: res.data,
          loading: false,
        };
        that.printConfig = {
          title: "Work Order Report",
          columns: res.columns,
          rows: that.orderList,
        };
        that.exceldata = that.getData(res.columns, res.data);
      });
  }

  getData(columns, data) {
    let cols = columns;
    let value = data;
    let rows = [],
      row,
      ind,
      type,
      val,
      rlen = data.length,
      clen = columns.length;

    for (let i = 0; i < data.length; i++) {
      let sno = i + 1;
      row = Object.assign({}, data[i]);
      let newrow = {
        Sno: sno,
      };
      for (let j = 1; j < clen; j++) {
        let type = cols[j].type,
          index = cols[j].index,
          prop = cols[j].prop,
          name = cols[j].name;

        newrow[name] = row[prop];
      }

      rows.push(newrow);
      sno++;
    }
    return rows;
  }

  getRowClass(event) {
    return event.rowtype == "summary" ? "summary-row" : "";
  }

  refreshData() {
    let columns = this.columns,
      data = this.dataList,
      row = this.getSummaryRow(data, columns);
    data.push(row);
    this.page.count = data.length;
    // this.dataList = data;
  }

  getSummaryRow(data, columns) {
    let row = {
      type: "summary",
    };
    for (let i = 0; i < columns.length; i++) {
      let col = columns[i];
      switch (col.summary) {
        case "sum":
          let total = 0;
          for (let j = 0; j < data.length; j++) {
            let dat = data[j];
            total += dat[col.prop];
          }
          row[col.prop] = Math.round(total * 100) / 100;
          break;
        default:
          row[col.prop] = "";
          break;
      }
    }
    return row;
  }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/Purchase/woreports/factoryStockreport.ts